export { default } from './FaqView';



// WEBPACK FOOTER //
// ./src/components/views/FaqView/index.js